<template>
  <div class="container d-flex flex-column">
    <!-- -->
    <div class="content flex-grow-1">
      <!-- <TipTapReader class="tiptap_style pa-0" :options="options" :key="componentKey + 'home'" /> -->
      <div class="content-html" v-html="sanitizeContent" :key="componentKey + 'homeSanitize'"></div>
    </div>
    <!-- <div class="bottom">
      <div class="d-flex justify-center">
        <v-btn text small to="/policy/rule?type=read" style="color: rgb(141, 141, 141)"> {{ $t("bottom.use_terms") }} </v-btn>
        <span style="color: rgb(141, 141, 141)">&nbsp;/&nbsp;</span>
        <v-btn class="font-weight-bold" text small to="/policy/privacy?type=read" style="color: rgb(141, 141, 141)"> {{ $t("bottom.private_terms") }}</v-btn>
      </div>
      <Bottom />
    </div> -->
    <IosInappBrowserWarningDialog
      v-if="use_ios_browser_warning && $i18n.locale === 'ko'"
      @input="(e) => (show_warning_dialog = e)"
      :visible="show_warning_dialog"
    />
    <InappBrowserWarningDialog
      v-else
      @input="(e) => (show_warning_dialog = e)"
      @confirm="show_warning_dialog = false"
      :visible="show_warning_dialog"
    />
  </div>
</template>
<script>
import Bottom from "./components/Bottom.vue"
import InappBrowserWarningDialog from "@/views/components/InappBrowserWarningDialog"
import IosInappBrowserWarningDialog from "@/views/components/IosInappBrowserWarningDialog"
import QrloginComplDialog from "@/views/components/QrcodeLoginCompleteDialog"
import { mapState, mapGetters, mapMutations } from "vuex"
import TipTapReader from "@/components/tiptap/Reader"
import htmlService from "../api/html-service"
import { isIOSDevice, shouldShowBrowserWarning } from "@/util/utils"

export default {
  components: {
    Bottom,
    InappBrowserWarningDialog,
    IosInappBrowserWarningDialog,
    QrloginComplDialog,
    TipTapReader,
  },

  created() {},

  data: () => ({
    show_warning_dialog: false,
    use_ios_browser_warning: isIOSDevice(),
    list: [],

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    htmlResource: null,
    sanitizeContent: "",
  }),

  mounted() {
    // 목록 불러오기
    // this.load()
    if (this.$route.query.qrlogin === "true") {
      this.qrlogin_compl_dialog = true
    }

    let lang = this.$route.query.lang
    if (lang && ["ko", "en", "jp"].includes(lang)) {
      this.SET_LANG(lang)
    }

    this.show_warning_dialog = shouldShowBrowserWarning()

    this.load()
  },

  computed: {
    ...mapState(["lang"]),

    mainTitleLogoFileName() {
      switch (this.lang) {
        case "ko":
          return "sela-main-title"
        case "jp":
          return "sela-main-title-jp"
        default:
          return "sela-main-title-en"
      }
    },
  },
  watch: {
    lang() {
      this.options.content = this.getContent()
      this.sanitizeContent = this.getContent()
      this.componentKey++
    },
  },

  methods: {
    ...mapMutations(["SET_LANG"]),
    // 목록 불러오기
    load() {
      htmlService.getHtmlBlobData("home").then((res) => {
        this.htmlResource = res
        this.options.content = this.getContent()
        this.sanitizeContent = this.getContent()
        console.log(this.sanitizeContent)
        this.componentKey++
      })
    },
    getContent() {
      if (!this.htmlResource) {
        return ""
      }
      if (process.env.VUE_APP_PREMIUM_TEST === "true") {
        // 카테고리 운영 테스트: 홈의 메인 화면을 테스트용 메인으로 바꿔 보여 준다.
        const content = (this.lang === "jp" ? this.htmlResource.content_jp : this.lang === "en" ? this.htmlResource.content_en : "") || this.htmlResource.content || ""
        return content.replace(/(?:https:\/\/lafia-studio\.com)?\/main_0(_eg|_jp)?\.html/g, "/premium_category_test/main_0$1.html")
      }
      switch (this.lang) {
        case "jp":
          return this.htmlResource.content_jp || this.htmlResource.content
        case "en":
          return this.htmlResource.content_en || this.htmlResource.content
        default:
          return this.htmlResource.content || ""
      }
    },
  },
}
</script>

<style scoped>
.content-html {
  width: 100%;
  height: 100%;
}
.container {
  position: relative;
  min-height: 100%;
  height: auto;
  background-color: white;
  margin: 0;
  padding: 0;
}
.content {
}

.bottom {
  width: 100%;
  height: 170px;
  background-color: #231232;
  border-top: 1px solid #c2bcba;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
